import * as React from "react";
import { ButtonOutline } from "@grandvisionhq/iris-ui";
/* empty css                  */
const SecondaryAction = ({ label, onClick }) => /* @__PURE__ */ React.createElement(ButtonOutline, { "data-t": "nav-button", className: "configurator-footer-nav", onPress: onClick }, label);
export {
  SecondaryAction
};
//# sourceMappingURL=SecondaryAction.js.map
